module.exports = "<div> <radio-list :question=question :complete=complete @go-next=goNext(score)></radio-list> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/q10.vue
 ** module id = 64
 ** module chunks = 1
 **/